export default function handleSalesForceFormsBlocks() {
    let $blocks = $('.js-form-download');

    if ($blocks.length > 0) {
        // Keep sticky state in sync when viewport height changes.
        $(window).off('resize').on('resize', () => {
            $blocks.each(function () {
                disableStickySidebarIfScreenSizeToSmall($(this));
            });
        });

        $blocks.each(function () {
            let $block = $(this);
            handleFormSubmissionBlock($block);
        });
    }
}

async function handleFormSubmissionBlock($block) {

    observeBoxHeightChangesAndRecalculateStickySidebar($block);

    setTimeout(() => {
        $block.addClass('remove-loader');
        disableStickySidebarIfScreenSizeToSmall($block);
    }, 5000);

    disableStickySidebarIfScreenSizeToSmall($block);

    let urlParams = new URLSearchParams(window.location.search);

    if (!urlParams.get('download') || urlParams.get('download') !== 'true') {
        return false;
    }

    $block.html(eotwJSXFactory('div', {className: 'loading-block'}));

    let postId = $block.data('post-id');

    try {
        const result = await getDownloadDetails(postId);
        if (result.success && result.content) {
            $block.html(result.content);
            $('.js-resources-download-scroll').attr('href', result.link).attr('download', '')
                                              .attr('target', '_blank')
                                              .removeClass('js-scroll-to js-resources-download-scroll');
        } else {
            $block.html(eotwJSXFactory('p', null, ["Sorry, there was a problem getting your download. Please try again later"]));
        }

        disableStickySidebarIfScreenSizeToSmall($block);
    } catch (error) {
        console.warn(error);
        $block.html(eotwJSXFactory('p', null, ["Sorry, there was a problem getting your download. Please try again later"]));
        disableStickySidebarIfScreenSizeToSmall($block);
    }
}


async function getDownloadDetails(postId) {
    return Ajax.post('eotw', 'resource_result', {
        resource_id: postId,
    });
}

function observeBoxHeightChangesAndRecalculateStickySidebar($block) {
    if (!$block.length || typeof ResizeObserver === 'undefined') {
        return;
    }

    if ($block.data('stickyResizeObserver')) {
        return;
    }

    const $sidebar = $block.parent('.resource-layout__sidebar');
    if (!$sidebar.length) {
        return;
    }

    const observer = new ResizeObserver(() => {
        disableStickySidebarIfScreenSizeToSmall($block);
    });

    observer.observe($block[0]);
    observer.observe($sidebar[0]);
    $block.data('stickyResizeObserver', observer);
}

function disableStickySidebarIfScreenSizeToSmall($block) {
    let $sidebar = $block.parent('.resource-layout__sidebar');

    if (!$sidebar.length) {
        return false;
    }

    let formBoxHeight = $sidebar.outerHeight() || 0;

    let hasRoomForStickySidebar = window.innerHeight > (formBoxHeight + 60);

    $sidebar.toggleClass('resource-layout__sidebar--no-sticky', !hasRoomForStickySidebar);

    return hasRoomForStickySidebar;
}
